<template>
  <div class="transaction-record">
    <div class="transaction-record-header">
      <h2 class="title">{{ $t('transactions') }}</h2>

      <div slot="header" class="action-bar">
        <button class="action-button" @click="showTradeSelect = true">
          {{ tradeType === null ? $t('all_button') : $t(`${DES_TRADE_TYPE[tradeType]}`) }}
          <md-icon name="arrow-down" color="#e5e5e5" size="sm" />
        </button>

        <button class="action-button" @click="showDatePicker = true">
          {{ tradeStartTime }}
          <md-icon name="arrow-down" color="#e5e5e5" size="sm" />
        </button>
      </div>
    </div>

    <md-scroll-view
      ref="scrollView"
      :scrolling-x="false"
      :auto-reflow="autoReflow"
      class="transaction-record-content"
      @end-reached="handleLoadMore"
    >
      <OrderList :is-empty="total === 0">
        <OrderItem
          v-for="(item, index) in tradeList"
          :key="index"
          :model="item"
        />
      </OrderList>

      <md-scroll-view-more
        v-if="total !== 0"
        :is-finished="tradeList.length >= total"
        :finished-text="$t('finished_text')"
        :loading-text="$t('loading_text')"
      />
    </md-scroll-view>

    <md-selector
      v-model="showTradeSelect"
      :default-value="tradeType"
      :data="tradeOptions"
      max-height="428px"
      :title="$t('transactionType')"
      large-radius
      :ok-text="$t('done')"
      :cancel-text="$t('cancel')"
      @confirm="handleChooseTradeType"
    />

    <md-date-picker
      ref="datePicker"
      v-model="showDatePicker"
      type="custom"
      :text-render="textRender"
      :title="$t('month_picker_title')"
      large-radius
      :ok-text="$t('done')"
      :cancel-text="$t('cancel')"
      :custom-types="['yyyy', 'MM']"
      :default-date="defaultDate"
      @confirm="handleSelectDate"
    />
  </div>
</template>

<script>
import { Icon, ScrollView, ScrollViewMore, Selector, DatePicker } from 'mand-mobile'
import OrderItem from '@/components/OrderItem'
import OrderList from '@/components/OrderList'
import formatTimestamp from '@/utils/format-timestamp'
import { listTradeRecord } from '@/api/home'
import { DES_TRADE_TYPE } from '@/constants'

export default {
  name: 'TransactionHistory',

  components: {
    [Icon.name]: Icon,
    [ScrollView.name]: ScrollView,
    [ScrollViewMore.name]: ScrollViewMore,
    [Selector.name]: Selector,
    [DatePicker.name]: DatePicker,
    OrderList,
    OrderItem
  },

  beforeRouteLeave (to, form, next) {
    this.autoReflow = false
    this.scrollTop = this.$refs.scrollView.getOffsets().top
    next()
  },

  data () {
    const tradeOptions = Object.keys(DES_TRADE_TYPE)
      .map(item => {
        return { value: item, text: this.$t(DES_TRADE_TYPE[item]) }
      })
    tradeOptions.unshift({ value: null, text: this.$t('all_button') })

    this.scrollTop = 0

    return {
      DES_TRADE_TYPE,
      showTradeSelect: false,
      showDatePicker: false,
      tradeList: [],
      pageNum: 1,
      pageSize: 10,
      tradeStartTime: formatTimestamp(new Date(), 'yyyy-MM'),
      defaultDate: new Date(),
      tradeType: null,
      total: 0,
      tradeOptions,
      autoReflow: false
    }
  },

  activated () {
    this.$nextTick(() => {
      this.$refs.scrollView.scrollTo(0, this.scrollTop, false)
      this.autoReflow = true
    })
  },

  created () {
    this.getTradeList(this.pageNum, result => {
      this.tradeList = result.data
      this.total = result.total
    })
  },

  methods: {
    textRender () {
      const args = Array.prototype.slice.call(arguments)
      const typeFormat = args[0] // 类型
      const column2Value = args[2] // 第3列选中值
      if (typeFormat === 'yyyy') {
        return args[1]
      }
      if (typeFormat === 'MM') {
        return `${column2Value}`.length === 1 ? `0${column2Value}` : `${column2Value}`
      }
    },
    getTradeList (pageNum, callback) {
      const { pageSize, tradeStartTime, tradeType } = this
      this.pageNum = pageNum
      listTradeRecord({
        pageNum,
        pageSize,
        tradeType,
        tradeStartTime
      }).then(callback)
    },
    handleLoadMore () {
      if (this.tradeList.length >= this.total) return

      this.getTradeList(this.pageNum + 1, result => {
        this.tradeList = [...this.tradeList, ...result.data]
        this.total = result.total
        this.$refs.scrollView.finishLoadMore()
      })
    },
    handleSelectDate () {
      this.tradeStartTime = this.$refs.datePicker.getFormatDate('yyyy-MM')

      this.getTradeList(1, result => {
        this.tradeList = result.data
        this.total = result.total
      })
    },
    handleChooseTradeType ({ value }) {
      this.tradeType = value

      this.getTradeList(1, result => {
        this.tradeList = result.data
        this.total = result.total
      })
    }
  }

}
</script>

<style scoped lang="scss">
.transaction-record {
  height: 100%;

  &-header {
    padding: 40px 40px 0 40px;
    height: 220px;
  }

  &-content {
    padding: 20px 40px 40px 40px;
    height: calc(100% - 220px);
  }

  .title {
    margin-bottom: 40px;
    color: #333;
    font-size: 36px;
  }
}

.action-button {
  margin-right: 18px;
  height: 64px;
  padding: 0 48px;
  background: #fff;
  border-radius: 32px;
  border: none;
  outline: none;
  box-shadow: 0 8px 32px 0 rgba(138, 149, 158, 0.2);
}

.action-bar {
  margin-bottom: 28px;
}
</style>
